import { Injectable } from '@angular/core';
import { ContractType, CoverType } from '@common/util-models';
import { filterNullUndefined } from '@domgen/dgx-fe-common';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { BasketState } from './basket.reducer';
import * as QuotesSelectors from './quotes/quotes.selectors';

@Injectable()
export class SkySalesQuotesFacade {
  selectedCoverType$: Observable<CoverType> = this.store
    .select(QuotesSelectors.getSelectedCoverType)
    .pipe(filterNullUndefined());

  isInsurance$: Observable<boolean> = this.store
    .select(QuotesSelectors.getIsInsurance)
    .pipe(filterNullUndefined());

  isMultiplePaymentOptions$: Observable<boolean> = of(false);

  isHeating$: Observable<boolean> = of(false);

  paymentTerm$: Observable<string> = this.store
    .select(QuotesSelectors.getPaymentTerm)
    .pipe(filterNullUndefined());

  selectedContractType$: Observable<ContractType> = this.store.pipe(
    select(QuotesSelectors.getSelectedContractType),
    filterNullUndefined()
  );

  constructor(private store: Store<BasketState>) {}
}
